import { apiWorkOrderRollbackInfo } from '@/api/workPlace/workOrder'
import { FreshRound, RefreshRoundManager } from '@/utils/rollBackManager.js'
const refreshRoundManager = new RefreshRoundManager()
import { queryAllGroupId } from '@/api/chat'

/**
 * 目前管理的Timer类型
 * @workOrderId 工单距离回滚倒计时
 * @AUTO_REST 坐班自动休息倒计时
 * @REFRESH_LIMIT 可执行刷新间隔倒计时
 */
const state = {
  // 定时器实例
  roundInstance: new Map(),
  // 区分回滚和临回滚时间节点
  rollBackSplit: '',
  // 默认倒计时时长
  defaultTimerLength: '',
  // 收到新消息判断是否有该消息群聊的工单
  selfGroupIDs: []
}
const mutations = {
  SET_ROUND_INSTANCE: (state, { timer, callBackTime }) => {
    const countDown = new FreshRound(timer, callBackTime)
    state.roundInstance.set(timer, countDown)
    refreshRoundManager.startCountdown()
  },
  CLEAR_ALLTIMER_ROUND(state) {
    refreshRoundManager.stopCountdown()
    state.roundInstance.clear()
  },
  SET_ROLLBACK_SPLIT(state, splitSecond) {
    state.rollBackSplit = splitSecond
  },
  SET_DEFAULT_TIMER_LENGTH(state, length) {
    state.defaultTimerLength = length
  },
  INIT_ROUND_INSTANCE(state) {
    state.roundInstance.clear()
  },
  SET_GROUP_IDS_SELF(state, res) {
    state.selfGroupIDs = res || []
  }
}
const actions = {
  // 获取工单倒计时
  getAllRefreshTimer({ commit }) {
    // 先清空
    commit('INIT_ROUND_INSTANCE')
    return new Promise((resolve, reject) => {
      apiWorkOrderRollbackInfo()
        .then(res => {
          const {
            rollbackTimeOut,
            workOrderInfoList = [],
            rollbackTime: defaultRollback
          } = res || {}
          commit('SET_ROLLBACK_SPLIT', rollbackTimeOut)
          commit('SET_DEFAULT_TIMER_LENGTH', defaultRollback)
          // 设置工单倒计时集合
          workOrderInfoList.forEach(({ workOrderId, rollbackTime }) => {
            workOrderId &&
              commit('SET_ROUND_INSTANCE', {
                timer: workOrderId,
                callBackTime: rollbackTime
              })
          })
          // 设置群组倒计时集合
          const groupInstance = turnToGroupInstance(workOrderInfoList)
          for (const key in groupInstance) {
            if (Object.prototype.hasOwnProperty.call(groupInstance, key)) {
              const { rollbackTime } = groupInstance[key]
              commit('SET_ROUND_INSTANCE', {
                timer: String(key),
                callBackTime: rollbackTime
              })
            }
          }
          console.log('state.roundInstance', state.roundInstance)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => {
          // 获取群组id
          getGroupId()
        })
    })

    function turnToGroupInstance(orderList) {
      const result = {}
      orderList.forEach(item => {
        if (!result[item.groupId] || item.rollbackTime < result[item.groupId].rollbackTime) {
          result[item.groupId] = item
        }
      })
      return result
    }

    async function getGroupId() {
      const data = await queryAllGroupId()
      commit('SET_GROUP_IDS_SELF', data)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
